import { render } from "./ReviewStep.vue?vue&type=template&id=8d60a566"
import script from "./ReviewStep.vue?vue&type=script&lang=js"
export * from "./ReviewStep.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__